module.exports = __webpack_public_path__ + "static/stratton-logo-eb5aa58559551e375b60208cbaa9695d.png";